import React from "react";
import { Room } from "models/Room";
import { queryStringService } from "services/query-string-service";
import { Subscription, Observable } from "rxjs";
import { AxiosError } from "axios";

export default function useRoomDetail(
  getRoomDetail: (id: number) => Observable<Room>
) {
  const [model, setModel] = React.useState<Room>(new Room());
  const [loadError, setLoadError] = React.useState<{ status?: number; message?: string } | null>(null);

  const { id } = queryStringService.useGetQueryString();

  React.useEffect(() => {
    const subscription: Subscription = new Subscription();
    if (id) {
      setLoadError(null);
      subscription.add(
        getRoomDetail(id).subscribe({
          next: (res: Room) => {
            setModel(res);
          },
          error: (error: AxiosError) => {
            setLoadError({
              status: error.response?.status,
              message: error.message,
            });
          },
        })
      );
    }

    return function cleanup() {
      subscription.unsubscribe();
    };
  }, [getRoomDetail, id]);

  return { model, setModel, loadError };
}
